module.exports = __webpack_public_path__ + "static/image/main/pc/banner-6-1.ver2_0_2.jpg?09d270ce";